import React from 'react';
import { ScheduleItem, Type } from '../../../../../api/responses';
import { formatTime } from './../../utils';
import { GroupName, PlayerNumber, TimeBadge } from './../../styles';
import {
  GameRow,
  Container,
  MobileTableWrapper,
  Row,
  Situation,
  PlayerContainer,
  Name,
  PlayerItem,
  Rating,
  Line,
  StartLine,
} from './styles';
import Judges from '../Judges';
import ReservedJudges from '../ReservedJudges';

type ScheduleTableProps = {
  gameItems: ScheduleItem[];
  competitionType: Type;
  lang: string;
};

const ScheduleTableMobile = ({
  gameItems,
  competitionType,
  lang = 'ru',
}: ScheduleTableProps) => (
  <>
    <StartLine $competitionType={competitionType} />
    <MobileTableWrapper $competitionType={competitionType}>
      {gameItems.map((game, index) => (
        <React.Fragment key={index}>
          <GameRow>
            <Container>
              <Row>
                <TimeBadge>
                  {formatTime(game.start_time)} - {formatTime(game.end_time)}
                </TimeBadge>
                <Situation>№ {game.game.game_number}</Situation>
              </Row>
              <Row>
                <GroupName>
                  {lang === 'ru' ? 'Группа' : 'Group'} {game.group_name}
                </GroupName>
                <Situation>
                  {lang === 'ru' ? 'Ситуация' : 'Case'} {game.game.case_number}
                </Situation>
              </Row>
            </Container>
            <Container>
              <PlayerContainer $isEmpty={!game.game.player_1}>
                {game.game.player_1 && (
                  <Row>
                    <PlayerItem>
                      <PlayerNumber $playerNumber={1}>1</PlayerNumber>
                      <Name>
                        {game.game.player_1.last_name}{' '}
                        {game.game.player_1.first_name}
                      </Name>
                    </PlayerItem>
                    <Name>
                      {game.game.score && game.game.score !== '0:0'
                        ? game.game.score.split(':')[0]
                        : ''}
                    </Name>
                  </Row>
                )}
                {game.game.rating_before && (
                  <Row>
                    <Rating>
                      {lang === 'ru'
                        ? 'Рейтинг до начала поединка'
                        : 'Initial rating'}
                    </Rating>
                    <Rating>{game.game.rating_before.player_1}</Rating>
                  </Row>
                )}
                {game.game.rating_after && (
                  <Row>
                    <Rating>
                      {lang === 'ru'
                        ? 'Рейтинг по итогу поединка'
                        : 'Definitive rating'}
                    </Rating>
                    <Rating>{game.game.rating_after.player_1}</Rating>
                  </Row>
                )}
              </PlayerContainer>
              <Line />
              <PlayerContainer $isEmpty={!game.game.player_2}>
                {game.game.player_2 && (
                  <Row>
                    <PlayerItem>
                      <PlayerNumber $playerNumber={2}>2</PlayerNumber>
                      <Name>
                        {game.game.player_2.last_name}{' '}
                        {game.game.player_2.first_name}
                      </Name>
                    </PlayerItem>
                    <Name>
                      {game.game.score && game.game.score !== '0:0'
                        ? game.game.score.split(':')[1]
                        : ''}
                    </Name>
                  </Row>
                )}
                {game.game.rating_before && (
                  <Row>
                    <Rating>
                      {lang === 'ru'
                        ? 'Рейтинг до начала поединка'
                        : 'Initial rating'}
                    </Rating>
                    <Rating>{game.game.rating_before.player_2}</Rating>
                  </Row>
                )}
                {game.game.rating_after && (
                  <Row>
                    <Rating>
                      {lang === 'ru'
                        ? 'Рейтинг по итогу поединка'
                        : 'Definitive rating'}
                    </Rating>
                    <Rating>{game.game.rating_after.player_2}</Rating>
                  </Row>
                )}
              </PlayerContainer>
            </Container>
            <Container>
              <Judges
                judges={game.game.judges}
                competitionType={competitionType}
                lang={lang}
              />
              {game.game.reserve_judge && (
                <ReservedJudges judges={game.game.reserve_judge} lang={lang} />
              )}
            </Container>
          </GameRow>
          {index < gameItems.length - 1 && <Line />}
        </React.Fragment>
      ))}
    </MobileTableWrapper>
  </>
);

export default ScheduleTableMobile;
